<script>
	import { ArticleV4 } from '$lib/modules/blog'
	import DynamicZone from '$lib/modules/cms/DynamicZone/DynamicZone.svelte'
	import { t } from '$lib/translations'
	import { FAQ } from '$lib/ui-woltair/components'

	export let data = null
</script>

{#if data.type === 'productPage'}
	<main class="page-wrapper mb-16 flex flex-col items-center">
		{#if data.type === 'landingPage'}<h1 class="!mb-12 text-center">{@html data.title}</h1>{/if}

		<div class="flex w-full flex-col gap-4">
			<DynamicZone componentData={data.components} />
		</div>
	</main>
{:else if data.type === 'article'}
	{#if data.article}
		<section class="page-wrapper">
			<ArticleV4 article={data.article} />
		</section>
	{/if}
	{#if data.faqs}
		<section class="page-wrapper relative mt-24">
			<FAQ faqs={data.faqs} />
		</section>
	{/if}
{:else if data.type === 'thankYou'}
	<img class="icon mx-auto !mt-14 block" src="/images/icons/icon-zamereni.svg" alt="Zaměření" />
	<h1 class="text-center">{t('web.forms.thankYou')}</h1>
	<p class="text-center text-neutral-500">
		{t('web.forms.expertCall')}
	</p>
{/if}
